import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import { sortByHighPriority } from 'Shared/utils/sorting';

export function buildHomePageTasksSortOrder(tasks) {
  const uuidsToPosition = [];
  tasks.forEach((task, index) => {
    uuidsToPosition.push({ uuid: task.uuid, positionForHomePage: index + 1 });
  });
  return uuidsToPosition;
}

export function assignedHomePageTasksPositions(items) {
  return items.map((task, index) => ({ ...task, positionForHomePage: index + 1 }));
}

export function recalculatePositions(itemsList, { draggedItemUuids, hoveredItemUuid, hoverOffset }) {
  const draggedItems = itemsList.filter(({ uuid }) => draggedItemUuids.includes(uuid));
  const meetingItemsWithoutDragged = itemsList.filter(({ uuid }) => !draggedItemUuids.includes(uuid));
  const hoveredItem = meetingItemsWithoutDragged.find(({ uuid }) => uuid === hoveredItemUuid);
  const hoveredIndex = meetingItemsWithoutDragged.indexOf(hoveredItem);
  const insertIndex = hoverOffset ? hoveredIndex + 1 : hoveredIndex;

  const meetingItemsWithNewPositions = [...meetingItemsWithoutDragged];

  meetingItemsWithNewPositions.splice(insertIndex, 0, ...draggedItems);
  return meetingItemsWithNewPositions;
}

export function getHomePageTasksAfterDrop(state, { draggedItemUuids, hoveredItemUuid, hoverOffset }) {
  const orderedTasks = sortByHighPriority(sortBy(state, ({ positionForHomePage }) => positionForHomePage));
  const meetingItemsWithNewPositions = recalculatePositions(orderedTasks, {
    draggedItemUuids,
    hoveredItemUuid,
    hoverOffset,
  });
  const result = assignedHomePageTasksPositions(meetingItemsWithNewPositions);

  return result;
}

export function mergedSyncList({ currentList, newList, deletedList = [], uniqField = 'uuid' }) {
  if (!currentList || !newList) return currentList;
  let mergedItems = newList.concat(currentList);
  mergedItems = uniqBy(mergedItems, uniqField);
  mergedItems = mergedItems.filter(m => !deletedList.find(d => d.uuid === m.uuid));
  return mergedItems;
}

export function mapObjectsForRedux(object) {
  const newObj = {};
  Object.keys(object).forEach(key => {
    newObj[object[key].attributes.uuid] = object[key].attributes;
  });
  return newObj;
}
